import { InvoiceDiscountType } from '../enums/invoiceDiscountType'

export type DiscountTypeTrackingValue = 'percentage' | 'fixed'

const discountTypeTrackingValueMap: Record<InvoiceDiscountType, DiscountTypeTrackingValue> = {
  [InvoiceDiscountType.Percentage]: 'percentage',
  [InvoiceDiscountType.Amount]: 'fixed',
}

export const getDiscountTypeTrackingValue = (discountType: InvoiceDiscountType): DiscountTypeTrackingValue =>
  discountTypeTrackingValueMap[discountType]
